import React, { useContext, useEffect, useRef, useState } from 'react';
import { Row, Col, Card, Tab, Nav, ButtonGroup, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';

// components
import PageTitle from '../../components/PageTitle';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ClientFile } from '../../interfaces/ClientFile';
import FileUploader from '../../components/FileUploader';
import { FileType } from '../../interfaces/FileType';
import { uploadFile } from '../../utils/api/files';
import FileGallery from './FileGallery';
import FilesList from './FilesList';
import { getClientFromStorage } from '../../utils/usersLocalStorage';
import { useQuery } from '../../hooks';
import { Client } from '../../interfaces/Client';
import { getClient } from '../../utils/api/clients';
import { UserProfileContext } from '../../context/userProfileContext';
import FilesPageContent from './FilesPageContent';
import Drawers from '../../components/Drowers';

const Files = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const mounted = useRef(false);

    const [client, setClient] = useState<Client>();
    const query = useQuery();

    const { profileContextData, setProfileContextData } = useContext(UserProfileContext);

    const handleClient = async () => {
        const clientId = query.get('clientId');
        if (!clientId) navigate('/clients');
        else {
            let client = profileContextData ? profileContextData.client : getClientFromStorage(clientId);
            if (!client || !client._id) {
                const result = await getClient(clientId);
                client = result.client;
            }
            setClient(client);
        }
    };

    useEffect(() => {
        mounted.current = true;
        if (mounted) {
            handleClient();
        }

        if (window.location.pathname.includes('files')) {
            setProfileContextData({
                ...profileContextData,
                selectedModule: undefined,
            });
        }

        return () => {
            mounted.current = false;
        };
    }, []);

    return (
        <div className="files">
            <Drawers client={client} selectedModule={profileContextData?.selectedModule?.data?.moduleName} openTasksCount={0} />

            {client && client._id ? <FilesPageContent client={client} /> : null}
        </div>
    );
};

export default Files;
